import Script from 'next/script';

export function BookitScript({ onLoad, scriptConfig }) {
  const { orgId, nodeName, useLocalStorage, options } = scriptConfig;
  return (
    <>
      <Script
        dangerouslySetInnerHTML={{
          __html: `
          window['LeanDataCalendaringObjName'] = '${scriptConfig.calendaringObjectName}';

          // Initialise if needed
          if (typeof window['${scriptConfig.calendaringObjectName}'] === 'undefined') {
            window['${scriptConfig.calendaringObjectName}'] = (...args) => {
              window['${scriptConfig.calendaringObjectName}'].variables = args;
            };
          }

          ${
            scriptConfig.calendaringObjectName
          }('${orgId}', '${nodeName}', ${useLocalStorage}, ${JSON.stringify(options)});
          `,
        }}
      />
      <Script src="https://app.leandata.com/js-snippet/ld_calendaring.js" onLoad={onLoad} />
    </>
  );
}
